
import XButton from 'vux/src/components/x-button/index.vue'

import {Fetch} from "../../utils/storage"
import {ParseTime} from "../../utils/time"
import {Api} from "../../utils/api"
import Pay from '../../utils/pay'

export default {
name: 'MemberUserOrder-New',
components: {
XButton
},
filters: {
/**
* @return {string}
*/
MeetingTimeFilter(val) {
let start = ParseTime(val.StartAt,'{y}-{m}-{d}')
let end = ParseTime(val.EndAt,'{y}-{m}-{d}')
return `${start} 至 ${end}`
}

},
data () {
return {
Committee:{},
CommitteeID: 0,
MemberUser: {},
MemberUserOrder: {},
MemberUserOrderID: 0,
MeetingList: [],
IsShowNotFound: false,
StatusMap: {
"to_pay": "待支付",
"paid": "已支付",
},
PositionMap: {
"chairman": "主委员",
"vice_chairman": "副委员",
"secretary_general": "秘书长",
"secretary": "秘书"
},
isMemberValid: false
}
},
async created () {
this.MemberUserOrderID = this.$route.params["member_user_order_id"]
if (!this.MemberUserOrderID) this.$router.go(-1)
this.MemberUserOrderID = parseInt(this.MemberUserOrderID)
this.UserID = Fetch("ID")
await this.FetchMemberUserOrder()
this.FetchMeetingList()
},
methods: {
ParseTime,
async FetchMemberUserOrder() {
let _this = this
let UserID = _this.UserID
let memberOrderRet = await Api('GetMemberUserOrderList', {
Data:{
ID: _this.MemberUserOrderID
},
Preloads:[
{Column:'Committee'},
{Column:'MemberUser'},
],
Limit:1000,
})
if (!memberOrderRet.data.List) {
_this.$vux.toast.show({
text:'获取会员信息出错',
type:'cancel',
})
this.$router.go(-1)
}
_this.MemberUserOrder = memberOrderRet.data.List[0]
_this.MemberUser = _this.MemberUserOrder.MemberUser
_this.Committee = _this.MemberUserOrder.Committee
_this.CommitteeID = _this.MemberUserOrder.Committee.ID
},
async FetchMeetingList() {
try {
let reqData = {
Data:{
Visible:1,
Status:'verified',
EnrollStartAt: new Date(),
CommitteeID: this.CommitteeID
},
Limit: 1000,
Select:'id,tittle,head_img,holding_city,start_at,end_at,note,enroll_start_at,meeting_type',
}
let res = await Api('GetMeetingList', reqData)
this.MeetingList = (res.data && res.data.List) ? res.data.List : []
if (this.MeetingList.length <1) this.IsShowNotFound = true
}catch(err){
this.$vux.toast.show({
text:'获取专委会会议错误！',
type:'cancel',
})
}
},
async handleWechatPay() {
if (true) {
let _this = this
try{
let res = await Api ('MemberUserOrderFakeSuccess', {
OrderID: _this.MemberUserOrderID
})
_this.$vux.toast.show({
text: '专委会会员报名并缴费成功！',
type: 'text',
width:'3rem'
})
_this.$router.go(0)

}catch (err) {
console.log(err)
this.$vux.confirm.show({
theme: 'ios',
content: '<span style="font-size:20px">获取支付请求失败</span>',
showCancelButton:false,
})
}
return

}

try{
let _this = this
let res = await Api('GetMemberUserOrderPrePay', {
OrderID: _this.MemberUserOrderID
})

Pay.invoke(
res.data,
function (){
_this.$vux.toast.show({
text: '专委会会员报名并缴费成功！您的缴费订单可在会员订单管理中查看',
type: 'text',
width:'3rem'
})
_this.$router.go(0)

},
function (){
_this.$vux.confirm.show({
theme: 'ios',
content: `
<p style="margin-bottom:10px;font-size:24px;font-weight: bold">微信支付失败</p>
<span style="font-size:20px">申请已经提交，但费用支付失败。点击下方左侧进行"重新支付",或点击右侧"查看详情"</span>
`,
confirmText:"稍后支付",
cancelText:"重新支付",
onCancel(){

_this.handleWechatPay(OrderID)
},
onConfirm() {
return
}
})
}
)
}catch(err){
this.$vux.confirm.show({
theme: 'ios',
content: '<span style="font-size:20px">获取支付请求失败</span>',
showCancelButton:false,
})

}
},
}
}
